// Static testimonials - these are curated customer reviews
export const testimonials = [
  {
    id: 1,
    name: 'Priya Sharma',
    location: 'Mumbai',
    rating: 5,
    text: 'The Dhan Yog bracelet has completely changed my financial situation. Within 2 months of wearing it, I got a promotion and unexpected bonus! Highly recommend.',
    product: 'Dhan Yog Bracelet',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80',
  },
  {
    id: 2,
    name: 'Rajesh Kumar',
    location: 'Delhi',
    rating: 5,
    text: 'Amazing quality and fast delivery. The Pyrite pyramid brings so much positive energy to my office. Business has improved significantly!',
    product: 'Pyrite Pyramid',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80',
  },
  {
    id: 3,
    name: 'Anita Verma',
    location: 'Bangalore',
    rating: 5,
    text: 'Got the Rose Quartz pendant for my daughter. She found her soulmate within 3 months! These products truly work. Thank you Astro Vastu Remedies!',
    product: 'Rose Quartz Pendant',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=200&q=80',
  },
  {
    id: 4,
    name: 'Vikram Singh',
    location: 'Jaipur',
    rating: 5,
    text: 'The 7 Mukhi Rudraksha is authentic and powerful. I can feel the difference in my meditation practice. Very happy with my purchase.',
    product: '7 Mukhi Rudraksha',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=200&q=80',
  },
];
